import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { injectAsyncReducer, store } from './store';
import { CHANGE_CONFIG } from './constants';
import { changePreviewHiddenComponents } from './actions';
/**
 * Inspiration https://github.com/react-boilerplate/react-boilerplate
 */
export const withReducer = (reducer) => (WrappedComponent) => {
    return class extends React.PureComponent {
        constructor(props) {
            super(props);
            injectAsyncReducer(props.componentIdent, makeReducer(reducer, store.getState().config.components[props.componentIdent], props.componentIdent));
            store.dispatch(changePreviewHiddenComponents());
        }
        static displayName = `withReducer(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
        render() {
            return _jsx(WrappedComponent, { ...this.props });
        }
    };
};
/**
 * Vytvori reducer, ktery si kontroluje, zda prichozi akce ma identifikator, odpovidajici nazvu reduceru
 * tedy nezpracovava akce, ktere mu nepatri.
 * Take nastavi vychozi state reduceru
 * @param reducer vlastni klasicky reducer
 * @param initState vychozi state
 * @param reducerName identifikator reduceru, pouzity pro kontrolu akci
 */
export const makeReducer = (reducer, initState = {}, reducerName = '') => (state = initState, action) => {
    // if (process.env.NODE_ENV !== 'production') {
    //     (action && action.componentIdent === reducerName) && console.log('action:', action);
    // }
    /** aplikuje pripadne zmeny v konfiguraci jednotlivych komponent */
    if (action.type === CHANGE_CONFIG) {
        const conf = action.config.components[reducerName];
        if (conf)
            return { ...state, ...conf };
    }
    return action && action.componentIdent === reducerName ? reducer(state, action) : state;
};
//# sourceMappingURL=withReducer.js.map